// oxlint-disable-next-line import-extensions/file-extension-required
import { coreCapabilitiesSupportedBrowsers } from './coreCapabilitiesSupportedBrowsers';

export const coreBrowserNotSupported = (): boolean =>
	!coreCapabilitiesSupportedBrowsers.test(navigator.userAgent);
